<template>
  <div class="table-responsive d-inline cohort-table" style="overflow: auto; position: relative;">
    <table class="table mb-0"
      v-blur="{
              isBlurred: isBlurred,
              opacity: 1,
              filter: 'blur(5px)',
              transition: 'all .3s linear',
              }"
      v-bind:class="{ blockInteraction: isBlurred }"
      :style="isBlurred ? 'pointer-events: none;' : ''"
    >
      <thead>
        <tr>
          <th style="width: 35%">Channel</th>
          <th
            class="cursor-pointer text-right pr-0"
            style="width: 15%"
            @click="
              sortKey = 'visit'
              sortDirection = sortDirection === 'desc' ? 'asc' : 'desc'
              sortBy()
            "
          >
            Visits
            <span
              v-bind:class="{
                visible: sortKey === 'visit',
                invisible: sortKey !== 'visit',
              }"
              ><font-awesome-icon
                v-if="sortDirection === 'desc'"
                icon="chevron-down" /><font-awesome-icon
                v-else
                icon="chevron-up"
            /></span>
          </th>
          <th
            class="cursor-pointer text-right"
            style="width: 15%"
            @click="
              sortKey = 'unique'
              sortDirection = sortDirection === 'desc' ? 'asc' : 'desc'
              sortBy()
            "
          >
            Unique
            <span
              v-bind:class="{
                visible: sortKey === 'unique',
                invisible: sortKey !== 'unique',
              }"
              ><font-awesome-icon
                v-if="sortDirection === 'desc'"
                icon="chevron-down" /><font-awesome-icon
                v-else
                icon="chevron-up"
            /></span>
          </th>
          <th
            class="cursor-pointer text-right pr-0"
            style="width: 18%"
            @click="
              sortKey = 'duration/visit'
              sortDirection = sortDirection === 'desc' ? 'asc' : 'desc'
              sortBy()
            "
          >
            Average time
            <span
              v-bind:class="{
                visible: sortKey === 'duration/visit',
                invisible: sortKey !== 'duration/visit',
              }"
              ><font-awesome-icon
                v-if="sortDirection === 'desc'"
                icon="chevron-down" /><font-awesome-icon
                v-else
                icon="chevron-up"
            /></span>
          </th>
          <th
            class="cursor-pointer text-right pr-0"
            style="width: 15%"
            @click="
              sortKey = 'bounceCount/unique'
              sortDirection = sortDirection === 'desc' ? 'asc' : 'desc'
              sortBy()
            "
          >
            Bounce
            <span
              v-bind:class="{
                visible: sortKey === 'bounceCount/unique',
                invisible: sortKey !== 'bounceCount/unique',
              }"
              ><font-awesome-icon
                v-if="sortDirection === 'desc'"
                icon="chevron-down" /><font-awesome-icon
                v-else
                icon="chevron-up"
            /></span>
          </th>
        </tr>
      </thead>
      <tbody :key="channelKey" v-if="isLoaded">
        <template v-for="(item, type) in data">
          <tr
            v-bind:key="type"
            @click="expandDetail(type)"
            v-bind:class="{ 'cursor-pointer': type !== 'direct' }"
          >
            <td
              class="fs-14"
              @click="
                (type === 'direct' && !isShareSession)
                  ? ((visitorIds = item.direct.visitor),
                    $modal.show('visitor-listing'))
                  : ''
              "
            >
              <span
                class="visible"
                v-bind:class="{
                  invisible: type === 'direct' || !Object.keys(item).length,
                }"
              >
                <font-awesome-icon
                  v-if="!expandDetailList.includes(type)"
                  icon="plus-square"
                  class="text-muted fa-sm mr-1"
                />
                <font-awesome-icon
                  v-else
                  icon="minus-square"
                  class="text-muted fa-sm mr-1"
                />
              </span>
              {{
                type === 'socialmedia'
                  ? 'Social Media'
                  : type === 'paid'
                  ? 'Paid Ads'
                  : type | capitalize
              }}
            </td>
            <td class="fs-14 text-right">{{ sumArr(item, 'visit') }}</td>
            <td class="fs-14 text-right">{{ sumArr(item, 'unique') }}</td>
            <td class="fs-14 text-right">
              {{
                secondsToTime(
                  ((sumArr(item, 'duration') / sumArr(item, 'visit')) *
                    sumArr(item, 'visit')) /
                    sumArr(item, 'unique')
                )
              }}
            </td>
            <td class="fs-14 text-right">
              {{
                Math.round(
                  (sumArr(item, 'bounceCount') / sumArr(item, 'unique')) * 100,
                  2
                ) || 0
              }}%
            </td>
          </tr>
          <template v-if="expandDetailList.includes(type)">
            <tr
              v-for="(detail, name) in item"
              v-bind:key="name"
              class="cursor-pointer"
              @click="(!isShareSession) ? visitorIds = detail.visitor : '' ,(!isShareSession) ? $modal.show('visitor-listing') : ''
              "
            >
              <td
                style="
                  background-color: rgba(var(--background-muted), 0.3);
                  padding-left: 30px !important;
                "
                class="fs-14"
              >
                <img
                  v-if="detail.domain"
                  :src="
                    'https://www.google.com/s2/favicons?domain=' + detail.domain
                  "
                  width="15"
                  height="15"
                  class="mr-1"
                />
                <a
                  v-if="type === 'website'"
                  target="_blank"
                  :href="'https://' + name"
                  class="a-link text-muted"
                  >{{ shorten(name, 24) }}</a
                >
                <span v-else>{{ shorten(name, 24) }}</span>
              </td>
              <td
                style="background-color: rgba(var(--background-muted), 0.3)"
                class="fs-14 text-right"
              >
                {{ detail.visit }}
              </td>
              <td
                style="background-color: rgba(var(--background-muted), 0.3)"
                class="fs-14 text-right"
              >
                {{ detail.unique }}
              </td>
              <td
                style="background-color: rgba(var(--background-muted), 0.3)"
                class="fs-14 text-right"
              >
                {{
                  secondsToTime(
                    ((detail.duration / detail.visit) * detail.visit) /
                      detail.unique
                  )
                }}
              </td>
              <td
                style="background-color: rgba(var(--background-muted), 0.3)"
                class="fs-14 text-right"
              >
                {{ Math.round((detail.bounceCount / detail.unique) * 100, 2) }}%
              </td>
            </tr>
          </template>
        </template>
      </tbody>
      <tbody v-else>
        <tr v-for="n in 3" v-bind:key="n">
          <td>
            <content-placeholders>
              <content-placeholders-heading :img="true" />
            </content-placeholders>
          </td>
          <td v-for="n in 4" v-bind:key="n" class="text-right">
            <font-awesome-icon
              icon="circle-notch"
              class="fa-spin text-muted fa-sm"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <modal
      style="z-index: 10000"
      name="visitor-listing"
      :adaptive="true"
      width="900px"
      height="auto"
      styles="border-radius: 10px;"
    >
      <div class="modal-view">
        <Contact
          fullpage="0"
          :title="title"
          :key="JSON.stringify(visitorIds)"
          :visitorIds="visitorIds"
        ></Contact>
      </div>
    </modal>
    <div v-if="isBlurred" @click="redirectToCheckout()" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: rgba(var(--main-color), 1);" class="text-white font-weight-bold rounded py-2 px-3 upgrade-full-access">Upgrade to have full access</div>
  </div>
</template>
<script>
const Contact = () => import('@/pages/Contact.vue')

/* eslint-disable */
export default {
  props: [
    'startDate',
    'endDate',
    'interval',
    'period',
    'visitors',
    'checkByVisitor',
  ],
  components: {
    Contact,
  },
  beforeMount(){
    this.assignValuesForShare()
  },
  mounted() {
      this.loadData()
  },
  watch: {},
  data: function () {
    return {
      title: '',
      visitorIds: [],
      data: null,
      channelKey: 0,
      sortKey: 'visit',
      sortDirection: 'desc',
      expandDetailList: [],
      isLoaded: false,
      tempWidgetId:0,
      tempjwt:'',
      tempCompany_id:'',
      secretPosition:17,
      isShareSession:false,
      isBlurred:false,
    }
  },
  methods: {
    redirectToCheckout() {
      window.location.href = 'https://app.howuku.com/checkout'
    },
    expandDetail(type) {
      if (type === 'direct') return
      if (this.expandDetailList.includes(type))
        this.expandDetailList = this.expandDetailList.filter((a) => a !== type)
      else this.expandDetailList.push(type)
    },
    sumArr(item, key) {
      let values = Object.values(item)
      return values.reduce((a, b) => a + Number(b[key]), 0)
    },
    secondsToTime: function (secs) {
      return secs <= 0 || !secs
        ? '-'
        : secs > 60
        ? ~~((secs % 3600) / 60) + 'm ' + (~~secs % 60) + 's'
        : ~~secs + 's'
    },
    isSocialMedia(ref) {
      ref = ref.toLowerCase()
      if (/reddit/.test(ref)) {
        return 'Reddit'
      }
      if (/facebook/.test(ref) || /fbclid/.test(ref)) {
        return 'Facebook'
      }
      if (/quora/.test(ref)) {
        return 'Quora'
      }
      if (/t.co\//.test(ref)) {
        return 'Twitter'
      }
      if (/linkedin/.test(ref)) {
        return 'Linkedin'
      }
      return false
    },
    getDomain(url) {
      try {
        return url
          .split('//')[1]
          .split('/')[0]
          .replace(/^www\./, '')
      } catch (e) {
        return url
      }
    },
    sortByValue(data, key, direction) {
      let desc = direction === 'desc'
      return Object.fromEntries(
        Object.entries(data).sort((x, y) =>
          !key.includes('/')
            ? desc
              ? y[1][key] - x[1][key]
              : x[1][key] - y[1][key]
            : desc
            ? Number(y[1][key.split('/')[0]] / y[1][key.split('/')[1]]) -
              Number(x[1][key.split('/')[0]] / x[1][key.split('/')[1]])
            : Number(x[1][key.split('/')[0]] / x[1][key.split('/')[1]]) -
              Number(y[1][key.split('/')[0]] / y[1][key.split('/')[1]])
        )
      )
    },
    sortByGrouped(data, key, direction) {
      let desc = direction === 'desc'
      return Object.fromEntries(
        Object.entries(data).sort((x, y) =>
          !key.includes('/')
            ? desc
              ? this.sumArr(y[1], key) - this.sumArr(x[1], key)
              : this.sumArr(x[1], key) - this.sumArr(y[1], key)
            : desc
            ? Number(
                this.sumArr(y[1], key.split('/')[0]) /
                  this.sumArr(y[1], key.split('/')[1])
              ) -
              Number(
                this.sumArr(x[1], key.split('/')[0]) /
                  this.sumArr(x[1], key.split('/')[1])
              )
            : Number(
                this.sumArr(x[1], key.split('/')[0]) /
                  this.sumArr(x[1], key.split('/')[1])
              ) -
              Number(
                this.sumArr(y[1], key.split('/')[0]) /
                  this.sumArr(y[1], key.split('/')[1])
              )
        )
      )
    },
    sortBy() {
      if (!this.expandDetailList.length)
        this.data = this.sortByGrouped(
          this.data,
          this.sortKey,
          this.sortDirection
        )
      for (let i in this.data) {
        this.data[i] = this.sortByValue(
          this.data[i],
          this.sortKey,
          this.sortDirection
        )
      }
      this.channelKey++
    },
    shorten(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(0, len) + '...'
      else return string
    },
    loadData: function () {
      this.isBlurred = this.$isFreePlan.includes(this.$session.get('paid_plan')) || this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))

      this.isLoaded = false
      this.$http
        .post(process.env.API_ENDPOINT + '/tracking/channel-ch', {
          widget_id: (!this.isShareSession) ? this.$session.get('widget_id') : this.tempWidgetId,
          interval: this.interval || 24,
          period: this.period || 'HOUR',
          startDate: this.startDate || null,
          endDate: this.endDate || null,
        },{          
          headers: {
          'jwt': this.tempjwt
        }})
        .then((result) => {
          let data = result.data
          let channel = {
            socialmedia: {},
            website: {},
            direct: {
              direct: {
                visit: 0,
                unique: 0,
                duration: 0,
                bounce: 0,
                bounceCount: 0,
                domain: 'example.com',
                visitor: [],
              },
            },
            campaign: {},
            paid: {},
            source: {},
          }

          data
            .filter(
              (item) =>
                !this.visitors ||
                (this.visitors && this.visitors.includes(item.visitor_id))
            )
            .map((item) => {
              let utmCampaignVal = null
              let utmSourceVal = null
              let paidChannel = null
              let website = this.getDomain(item.vreferrer || item.referrer)
              let landingPage = item.landing_page || ''
              let matchCampaign = /utm_campaign=([a-z0-9\-\_]+)\&?/i
              let matchSource = /utm_source=([a-z0-9\-\_]+)\&?/i

              try {
                utmCampaignVal = JSON.parse(item.property)
                utmCampaignVal = utmCampaignVal.utm_campaign
              } catch (err) {}

              if (!utmCampaignVal)
                try {
                  let campaign = item.url
                    .replace(/HOWUKUPAGECOUNT/g, '&')
                    .match(matchCampaign)[1]
                  if (campaign) {
                    utmCampaignVal = campaign
                  }
                } catch (err) {}

              try {
                let source = item.url
                  .replace(/HOWUKUPAGECOUNT/g, '&')
                  .match(matchSource)[1]
                if (source) {
                  utmSourceVal = source
                }
              } catch (err) {}
              // if (item.url.includes('utm_source')) {
              //   console.log(utmSourceVal, item.url)
              // }
              // defining paid ads
              if (
                item.url.toLowerCase().includes('wbraid=') ||
                landingPage.toLowerCase().includes('wbraid=') ||
                item.url.toLowerCase().includes('gbraid=') ||
                landingPage.toLowerCase().includes('gbraid=') ||
                landingPage.includes('gclid=') ||
                landingPage.includes('gclsrc=') ||
                landingPage.includes('dclid=') ||
                item.url.includes('gclid=') ||
                item.url.includes('gclsrc=') ||
                item.url.includes('dclid=')
              )
                paidChannel = 'Google Adwords'

              if (website.includes('googleads.g.doubleclick.net'))
                paidChannel = 'Google Display Network'

              if (
                (item.url.includes('gclid=') ||
                  item.url.includes('gclsrc=') ||
                  item.url.includes('dclid=')) &&
                website === 'youtube.com'
              )
                paidChannel = 'Youtube'

              if (item.url.includes('msclkid=')) paidChannel = 'Bing Adwords'
              if (item.url.includes('fbclid=')) paidChannel = 'Facebook Ads'
              if (item.url.includes('twclid=')) paidChannel = 'Twitter Ads'

              if (paidChannel) {
                if (!channel.paid[paidChannel])
                  channel.paid[paidChannel] = {
                    visit: 0,
                    unique: 0,
                    duration: 0,
                    bounce: 0,
                    bounceCount: 0,
                    domain: '',
                    visitor: [],
                  }
                channel.paid[paidChannel].visit += Number(item.count)
                channel.paid[paidChannel].unique++
                channel.paid[paidChannel].duration += Number(item.duration)
                channel.paid[paidChannel].bounceCount +=
                  Number(item.count) === 1 ? 1 : 0
                channel.paid[paidChannel].visitor.push(item.visitor_id)
              } else if (
                utmCampaignVal ||
                (item.vurl || item.url).includes('utm_campaign')
              ) {
                let campaign

                if (utmCampaignVal) campaign = utmCampaignVal
                else
                  campaign = (item.vurl || item.url)
                    .split('utm_campaign=')[1]
                    .split('&')[0]
                    .split('#')[0]
                    .split('HOWUKUPAGECOUNT')[0]

                if (!channel.campaign[campaign])
                  channel.campaign[campaign] = {
                    visit: 0,
                    unique: 0,
                    duration: 0,
                    bounce: 0,
                    bounceCount: 0,
                    domain: '',
                    visitor: [],
                  }
                channel.campaign[campaign].visit += Number(item.count)
                channel.campaign[campaign].unique++
                channel.campaign[campaign].duration += Number(item.duration)
                channel.campaign[campaign].bounceCount +=
                  Number(item.count) === 1 ? 1 : 0
                channel.campaign[campaign].visitor.push(item.visitor_id)
              } else if (
                utmSourceVal ||
                (item.vurl || item.url).includes('utm_source')
              ) {
                let source

                if (utmSourceVal) source = utmSourceVal
                else
                  source = (item.vurl || item.url)
                    .split('utm_source=')[1]
                    .split('&')[0]
                    .split('#')[0]
                    .split('HOWUKUPAGECOUNT')[0]

                if (!channel.source[source])
                  channel.source[source] = {
                    visit: 0,
                    unique: 0,
                    duration: 0,
                    bounce: 0,
                    bounceCount: 0,
                    domain: '',
                    visitor: [],
                  }
                channel.source[source].visit += Number(item.count)
                channel.source[source].unique++
                channel.source[source].duration += Number(item.duration)
                channel.source[source].bounceCount +=
                  Number(item.count) === 1 ? 1 : 0
                channel.source[source].visitor.push(item.visitor_id)
              } else if ((item.vreferrer || item.referrer) === '') {
                channel.direct.direct.visit += Number(item.count)
                channel.direct.direct.unique++
                channel.direct.direct.duration += Number(item.duration)
                channel.direct.direct.bounceCount +=
                  Number(item.count) === 1 ? 1 : 0
                channel.direct.direct.visitor.push(item.visitor_id)
              } else if (this.isSocialMedia(item.vreferrer || item.referrer)) {
                let socialMedia = this.isSocialMedia(
                  item.vreferrer || item.referrer
                )
                if (!channel.socialmedia[socialMedia])
                  channel.socialmedia[socialMedia] = {
                    visit: 0,
                    unique: 0,
                    duration: 0,
                    bounce: 0,
                    bounceCount: 0,
                    domain: socialMedia + '.com',
                    visitor: [],
                  }
                channel.socialmedia[socialMedia].visit += Number(item.count)
                channel.socialmedia[socialMedia].unique++
                channel.socialmedia[socialMedia].duration += Number(
                  item.duration
                )
                channel.socialmedia[socialMedia].bounceCount +=
                  Number(item.count) === 1 ? 1 : 0
                channel.socialmedia[socialMedia].visitor.push(item.visitor_id)
              } else {
                if (!channel.website[website])
                  channel.website[website] = {
                    visit: 0,
                    unique: 0,
                    duration: 0,
                    bounce: 0,
                    bounceCount: 0,
                    domain: website,
                    original: item.vreferrer || item.referrer,
                    visitor: [],
                  }

                channel.website[website].visit += Number(item.count)
                channel.website[website].unique++
                channel.website[website].duration += Number(item.duration)
                channel.website[website].bounceCount +=
                  Number(item.count) === 1 ? 1 : 0
                channel.website[website].visitor.push(item.visitor_id)
              }
            })

          this.data = channel
          this.sortBy('visit')
          this.isLoaded = true
        })
    },
    assignValuesForShare(){
      if(!this.$route.params.encryptedParam){
        this.tempjwt = localStorage.getItem('jwt')
        this.tempWidgetId = this.$session.get('widget_id')
      }else{
        //if is not share session then assign 
        this.isShareSession = true
        this.tempjwt = window.TEMP_JWT
        this.tempWidgetId = window.TEMP_WIDGET_ID
        this.tempCompany_id = window.TEMP_COMPANY_ID
      }
    },
  },
}
</script>
<style scoped>
.modal-view {
  max-height: 100%;
  overflow: auto;
}
.upgrade-full-access:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/AcquisitionChannel.vue